import { render, staticRenderFns } from "./CreateTag.vue?vue&type=template&id=a94b8512"
import script from "./CreateTag.vue?vue&type=script&lang=js"
export * from "./CreateTag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\_ASNET\\01_projects\\05_chatannie\\01_git\\chatbot\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a94b8512')) {
      api.createRecord('a94b8512', component.options)
    } else {
      api.reload('a94b8512', component.options)
    }
    module.hot.accept("./CreateTag.vue?vue&type=template&id=a94b8512", function () {
      api.rerender('a94b8512', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/FormStory/Modals/CreateTag.vue"
export default component.exports